<template>
    <div class="setting identification">
        <van-nav-bar
            title="实名认证"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="identification-box">
            <div class="identification-info flex-space-between">
                <div class="identification-info-left">
                    <p>实名认证成功</p>
                    <p>{{userInfo.name}}</p>
                    <p>{{userInfo.idCardNo}}</p>
                </div>
                <div class="identification-info-right">
                    <div class="info-img">
                        <img src="../../../assets/images/account/userdefault.png" alt="">
                    </div>
                </div>
            </div>
            <div class="setting-item flex-space-between" >
                <p>证件照片</p>
                <div class="setting-item-right" >
                    <p>{{userInfo.idAuthStatus===1?'已上传':'未上传'}}</p>
                </div>
            </div>
            <div class="setting-item flex-space-between">
                <p>人像照片</p>
                <div class="setting-item-right" >
                    <p>{{userInfo.faceAuthStatus===1?'已上传':'未上传'}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: "identification",
    data(){
        return{
            faceShow:false,
            authShow:false,
            userInfo: {}
        }
    },
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('WDuserInfo'));
    },
    created(){
        // this.accountProfile();
    },
    methods:{
        onClickLeft() {
            this.$router.go(-1);
        },
        // accountProfile(){
        //     this.$api.account.accountProfile(1).then(res => {
        //         console.debug(res);
        //         if (res.data) {
        //         this.userInfo = res.data;
        //         }
        //     })
        // },
    }
}
</script>
<style lang="stylus" scoped>
    .flex-space-between{
        display :flex;
        justify-content:space-between;
        align-items :center;
    }
    .align-items-center{
        display :flex;
        align-items :center;
    }
    .setting{
        .identification-box{
            padding:0 30px;
        }
        .identification-info{
            margin-top:50px;
            height:400px;
            padding:0 50px 0 60px;
            box-sizing :border-box;
            background:url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/account/inbg.png') no-repeat center center;
            background-size:cover;
            .identification-info-right{
                .info-img{
                    width:200px;
                    height:200px;
                    border-radius:50%;
                    box-sizing :border-box;
                    background:url('../../../assets/images/account/avtabg.png') no-repeat;
                    background-position center
                    background-size:cover;
                    text-align center
                    padding-top 18px
                    img{
                        width:160px;
                        height:160px;
                        border-radius:50%;
                    }
                }
            }
            p{
                color:#fff;
                font-size:30px;
                margin-bottom:20px;
                &:nth-child(1){
                    font-size :40px;
                    margin-bottom:30px;
                }
            }
        }
        .setting-item{
            margin-top:30px;
            padding:38px 0;
            border-bottom:1px solid #EAEAEA;
            &:p:nth-child(1){
                padding:20px 0;
            }
            .setting-item-left{
                p{
                    color:#333333;
                    font-size:30px;
                }
            }
            .setting-item-right{
                img{
                    width:100px;
                    height:100px;
                    border-radius:50%;
                }
                p{
                    color:#666;
                    font-size:26px;
                }
            }
        }
    }
</style>